const formatDate = (minYear: number) => {
	let newDate = new Date()
	newDate.setDate(newDate.getDate() + 1)
	const date = newDate.getDate()
	const month = newDate.getMonth() + 1
	const year = newDate.getFullYear() - minYear

	return `${year}-${month < 10 ? `0${month}` : `${month}`}-${date < 10 ? `0${date}` : date}`
}

export const getMinBirthDate = () => {
	return formatDate(80)
}

export const getDefaultBirthDate = () => {
	return formatDate(20)
}